module.exports = __webpack_public_path__ + "54bddc3a6e96c12effe59d9619f3b0bf.jpg";